<script setup lang="ts">
withDefaults(
  defineProps<{
    image?: { img: string; alt: string }
  }>(),
  {
    image: () => ({
      img: '',
      alt: '',
    }),
  },
)
defineSlots<{
  'bottom-left'(): any
  'bottom-right'(): any
  'top-left'(): any
  'top-right'(): any
  background(): any
}>()
</script>

<template>
  <div class="base-overlay-image relative">
    <slot name="background">
      <div class="absolute inset-x-0 top-0">
        <BaseNuxtImg
          :alt="image.alt"
          :src="image.img"
          width="790"
          height="260"
          class="base-overlay-image__image"
        />
      </div>
    </slot>
    <div
      class="relative z-20 h-full pb-4 pl-8 pr-6 pt-6 md:pl-10 md:pr-5 md:pt-5"
    >
      <div class="flex h-1/2">
        <div v-if="$slots['top-left']" class="flex flex-1 items-start">
          <slot name="top-left" />
        </div>
        <div v-if="$slots['top-right']" class="flex flex-1 justify-end">
          <slot name="top-right" />
        </div>
      </div>
      <div class="flex h-1/2">
        <div v-if="$slots['bottom-left']" class="flex flex-1 items-end">
          <slot name="bottom-left" />
        </div>
        <div
          v-if="$slots['bottom-right']"
          class="flex flex-1 items-end justify-end"
        >
          <slot name="bottom-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.base-overlay-image,
.base-overlay-image__image {
  height: 250px;
}

@screen md {
  .base-overlay-image,
  .base-overlay-image__image {
    height: 260px;
  }
}

.base-overlay-image::after {
  content: '';
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  @apply absolute z-10 bottom-0 left-0 w-full h-1/2;
}
</style>
